import React from 'react';
import { useSelector } from 'react-redux';
import BN from 'bignumber.js';
import stylesParent from '../../../styles/frame/frame.module.scss';
import styles from '../../../styles/stake/stake-confirm.module.scss';
import Header from '../../../../../../../components/Stake/header';
import BondlyUsdtUniIcon from '../../../../../../../assets/images/bondly-usdt.svg';
import { formatToken } from '../../../../../../../helpers/token-helper';
import theme from '../../../../../../../theme';
import loading from '../../../../../../../assets/images/loading.png';

const ClaimConfirm = () => {
  const { rewardBalance, rewardEarned } = useSelector((state) => state.BONDLYUSDTUNIstake.stake);

  return (
    <>
      <Header icon={BondlyUsdtUniIcon} title='BONDLY/USDT-Staking' />
      <div className={stylesParent.cardContent}>
        <div>
          <div className={stylesParent.cardTextRow}>
            <div className={stylesParent.cardTextRowLabel}>You Are Claiming:</div>
            <div className={stylesParent.cardTextRowValue}>
              <b>{formatToken(new BN(rewardBalance).plus(rewardEarned).toString(10), 10)} BONDLY</b>
            </div>
          </div>
        </div>
        <div className={styles.descriptionContainer}>
          <div>
            <img src={loading} className='rotate' alt='' />
          </div>
          <div className={styles.confirm}>
            <span style={{ color: theme.palette.mantra.pink, fontWeight: 800 }}>Confirming...</span>
          </div>
        </div>
      </div>
    </>
  );
};

export default ClaimConfirm;
